export const unidades = [
  { id: '', title: 'Selecciona una opción' },
  { id: 'Nissan 2014', title: 'Nissan 2014' },
  { id: 'Camioneta Ford', title: 'Camioneta Ford' },
  { id: 'Camión Ford', title: 'Camión Ford' },
  { id: 'International', title: 'International' },
  { id: 'Kenworth 10', title: 'Kenworth 10' },
  { id: 'Kenworth 18', title: 'Kenworth 18 (Tortón)' },
]
